module.exports = __webpack_public_path__ + "img/banner_fengxianbaogao.9aede61f.png";